import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAddNewQuestionSetMutation } from "./questionSetsApiSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleRight,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import TimeLeft from "../../partial/TimeLeft";
import Uploader from "../../partial/Uploader";
import ReactQuill from "react-quill";
import Questions from "./partial/Questions";

const NewQuestionSetForm = ({ courses, questionSet }) => {
  const { groupId , type} = useParams();
  const [addNewQuestionSet, { isLoading, isSuccess, isError, error }] =
    useAddNewQuestionSetMutation();

  const navigate = useNavigate();
  const [title, setTitle] = useState(questionSet?.title || "");
  const [course, setCourse] = useState(questionSet?.course || "");
  const [questions, setQuestions] = useState(questionSet?.questions || []);
  const [minimumPassed, setMinimumPassed] = useState(
    questionSet?.minimumPassed || 0
  );

  useEffect(() => {
    if (isSuccess) {
      setTitle("");
      setCourse("");
      setQuestions([]);
      setMinimumPassed(0);
      navigate(`/${type}/${groupId}/question-sets`);
    }
  }, [isSuccess, groupId, navigate]);
  const nullQuestionList = questions.filter(c=> !c.title || c.answerOptions.length < 2)
  //console.log(questions)
  const nullAnswers = questions.map(q=>{
    return q.answerOptions?.filter(f=>!f.answerBody ||f.answerBody.length===0)
  })

  const merged = [].concat.apply([], nullAnswers);

  const canSave =
    [title, course, questions.length, nullQuestionList.length ===0, merged.length ===0].every(Boolean) && !isLoading;

  const onSaveQuestionSetClicked = async (e) => {
    e.preventDefault();
    if (canSave) {
      const { data } = await addNewQuestionSet({
        course,
        title,
        questions,
        minimumPassed,
      });
      //  if(data?.id)
      //     navigate(`/${type}/${groupId}/question-sets/${data?.id}`)
      // }
    }
  };

  const options = courses.map((course) => {
    return (
      <option key={course.id} value={course.id}>
        {" "}
        {course.name}
      </option>
    );
  });

  const errClass = isError ? "errmsg" : "offscreen";

  const content = (
    <>
      <p className={errClass}>{error?.data?.message}</p>
       <p className='errmsg'>{(questions.length ===0 || nullQuestionList.length ) ? 'יש להכניס שאלות עם לפחות 2 תשובות':''}</p>
      <p className='errmsg'>{(merged.length ) ? 'חובה להכניס תוכן לתשובות':''}</p>

      <form className="form">
        <div className="form__title-row">
          <h2>New QuestionSet</h2>
          <div className="form__action-buttons">
            <button
              className="icon-button"
              title="Back"
              onClick={() => {
                navigate(`/${type}/${groupId}/question-sets`);
              }}
            >
              <FontAwesomeIcon icon={faArrowAltCircleRight} />
            </button>
            <button onClick={onSaveQuestionSetClicked} className="icon-button" title="Save" disabled={!canSave}>
              <FontAwesomeIcon icon={faSave} />
            </button>
          </div>
        </div>
        <label className="form__label" htmlFor="title">
          כותרת שאלון:
        </label>
        <input
          className={`form__input  ${!title && "form__input--incomplete"}`}
          id="title"
          maxLength={100}
          name="title"
          type="text"
          autoComplete="off"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <div className="form-flex">
          <div className="form-input-container">
            <label
              className="form__label form__checkbox-container"
              htmlFor="group"
            >
              Course:
            </label>
            <select
              id="group"
              name="group"
              className={`form__input  ${!course && "form__input--incomplete"}`}
              value={course}
              onChange={(e) => setCourse(e.target.value)}
            >
              <option></option>
              {options}
            </select>
          </div>
          <div className="form-input-container">
            <label className="form__label" htmlFor="action-order">
              Minimum Passed:
            </label>
            <input
              className={`form__input `}
              id="action-order"
              name="minimumPassed"
              type="number"
              autoComplete="off"
              value={minimumPassed}
              onChange={(e) => setMinimumPassed(e.target.value)}
            />
          </div>
        </div>
        <Questions   questions={questions} setQuestions={setQuestions} />
      </form>
    </>
  );

  return content;
};

export default NewQuestionSetForm;
